(function () { if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing"); })();

(function (Controller, Model, Service, Helper) {
    'use strict';

    Controller.FbInstantArticlesVentaPromise = (resolve, reject) => {
        if (Model.IsInstantArticles()) {
            Service.ventaFacebook({
                "cd": {
                    "value": Model.PlanElegido.precio,
                    "currency": "ARS"
                }
            },function (obj) {
                if (obj.code === "0000") {
                    Model.ExternalPaywall.AutorizationToken = obj.response;
                    resolve("OK");
                }
                else {
                    reject("Not OK");
                }
             })
        }
        else {
            resolve("Not OK");
        }
    }


    Controller.FbInstantArticlesYaTengoPromise = (resolve, reject) => {
        const closeWindow = () => {
            window.open('', '_self').close();
        }
        if (Model.IsInstantArticles()) {
            Service.ventaFacebookYaTenia({
                "cd": {
                    "is_subscriber": "true"
                }
            }, function (obj) {
                if (obj.code === "0000") {
                    Model.ExternalPaywall.AutorizationToken = obj.response;
                    Helper.resetImg('externalPaywallToken', Model.ExternalPaywall.AutorizationToken, () => {
                        console.log('resolve externalPaywallToken');
                        resolve(closeWindow)
                    });
                }
                else {
                    reject("Not OK");
                }
            })
        }
        else {
            resolve("Not OK");
        }
    }


})(LN.Controller, LN.Model, LN.Service, LN.Helper);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/fbInstantArticlesController.js